module.exports = __webpack_public_path__ + "static/media/explosion-loop.54fdbdb.ogg";


//////////////////
// WEBPACK FOOTER
// ./static/audio/explosion-loop.ogg
// module id = qMuw
// module chunks = 1